export function convertLabelStatusToValue(status: string) {
  return status.replace(/[\s-]+/g, "_").toUpperCase();
}
